module.exports = __webpack_public_path__ + "img/Chelsea-Icon.ddcd1ed3.png";